import { ModelFactory } from '@shared/factories/model.factory';
import { RoleType } from '@generated/graphql';
import { Role } from '@modules/role/models/role.model';

export class RoleFactory extends ModelFactory<RoleType, Role> {
  create (state: RoleType): Role {
    return new Role(state);
  }
}

export const roleFactory = new RoleFactory();
